import { StoneXRow } from '../../../StoneX';
import StoneXMainPage from '../../../StoneX/StoneXMainPage/StoneXMainPage';
import MatrixReport from './MatrixReport';

export default function MatrixTool() {
  return (
    <StoneXMainPage>
      <StoneXRow>
        <h1>Matrix</h1>
      </StoneXRow>
      <MatrixReport />
    </StoneXMainPage>
  );
}
